import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6557fa0f")

_pushScopeId("data-v-6557fa0f")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Automezzi")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "nuova_prenotazione" }
const _hoisted_5 = {
  key: 0,
  class: "no_prenotazioni_container"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "no_prenotazioni" }, "Nessuna prenotazione effettuata", -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "container_prenotazioni" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "marca" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadPrenotazioni()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", {
                    class: "prenotazione_button",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.openModal && $setup.openModal(...args)))
                  }, "Prenota")
                ]),
                (!$setup.prenotazioni.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _hoisted_6
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode("div", _hoisted_8, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.prenotazioni, (prenotazione) => {
                          return (_openBlock(), _createBlock("div", {
                            key: prenotazione.prenotazioni_automezzi_id,
                            onClick: ($event: any) => ($setup.openDetailModal(prenotazione)),
                            class: "prenotazione"
                          }, [
                            _createVNode("div", _hoisted_9, _toDisplayString($setup.dataPrenotazione(prenotazione.prenotazioni_automezzi_data_ora_inizio, prenotazione.prenotazioni_automezzi_data_ora_fine)), 1),
                            _createVNode("div", _hoisted_10, " Dalle " + _toDisplayString($setup.timeFormat(prenotazione.prenotazioni_automezzi_data_ora_inizio)) + " alle " + _toDisplayString($setup.timeFormat(prenotazione.prenotazioni_automezzi_data_ora_fine)), 1),
                            _createVNode("div", _hoisted_11, _toDisplayString(prenotazione.automezzi_marca) + " - " + _toDisplayString(prenotazione.automezzi_modello), 1)
                          ], 8, ["onClick"]))
                        }), 128))
                      ])
                    ]))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})